// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const ga: KnowledgePagesCopy = {
  knowledgePage: 'Leathanach eolais',
  knowledgePages: 'Leathanaigh eolais',
  featureOffTitle: 'Níl leathanaigh eolais cumasaithe sa spás oibre seo.',
  featureOffBody: 'Tá comhthéacs agus foinsí na cuideachta fós in Eolas.',
  loadingPage: 'Ag lódáil an leathanaigh…',
  loadingSuggestion: 'Ag lódáil an mholta…',
  cancel: 'Cealaigh',
  tryAgain: 'Bain triail eile as',
  everyoneIn: 'Gach duine ag {company}',
  yourCompany: 'do chuideachta',
  revision: 'Leagan {n}',
  openRevision: 'Oscail leagan {n}',
  pageCount: 'one:leathanach|two:leathanach|few:leathanach|many:leathanach|other:leathanach',
  topicCount: 'one:ábhar|two:ábhar|few:ábhar|many:n-ábhar|other:ábhar',
  sectionCount: 'one:roinn|two:roinn|few:roinn|many:roinn|other:roinn',
  lineCount: 'one:líne|two:líne|few:líne|many:líne|other:líne',
  documentCount: 'one:doiciméad|two:dhoiciméad|few:dhoiciméad|many:ndoiciméad|other:doiciméad',
  changeCount: 'one:athrú|two:athrú|few:athrú|many:n-athrú|other:athrú',
  newPageCount:
    'one:leathanach nua|two:leathanach nua|few:leathanach nua|many:leathanach nua|other:leathanach nua',
  changedPageCount:
    'one:leathanach athraithe|two:leathanach athraithe|few:leathanach athraithe|many:leathanach athraithe|other:leathanach athraithe',
  otherSectionCount:
    'one:roinn eile|two:roinn eile|few:roinn eile|many:roinn eile|other:roinn eile',
  characterCount: 'one:carachtar|two:charachtar|few:charachtar|many:gcarachtar|other:carachtar',
  diffStats: '{sections} athraithe · {added} curtha leis · {removed} bainte',
  diffMatchesBase: 'Tá an téacs molta mar an gcéanna leis an mbunleagan.',
  diffIntroduction: 'Réamhrá',
  diffOtherUnchanged: '{sections} gan athrú.',
  timeJustNow: 'díreach anois',
  originImportedFrom: 'Iompórtáilte ó {path}',
  originImportedFromCommit: 'Iompórtáilte ó {path} @ {commit}',
  authorityApprovedInPoneva: 'Ceadaithe in Poneva',
  authorityImported: 'Iompórtáilte',
  authorityInRepository: '{canonicality} sa stór',
  authorityVerified: 'fíoraithe {date}',
  authorRepositoryImport: 'Iompórtáil ón stór',
  authorSuggestedInChat: 'Molta sa chomhrá',
  authorSuggestedInChatWith: 'Molta sa chomhrá le {name}',
  authorSuggestedBy: 'Molta ag {name}',
  authorSuggestedByApp: 'Molta ag aip cheangailte',
  authorSuggestedByColleague: 'Molta ag comhghleacaí',
  authorSuggestedByYou: 'Molta agatsa',
  authorSuggestedOnBehalf: 'Molta ag {app} thar ceann {name}',
  authorSuggestedByAppOnBehalf: 'Molta ag aip cheangailte thar ceann {name}',
  authorSuggestedAndApproved: 'Molta agus ceadaithe ag {name}',
  approverApprovedBy: 'ceadaithe ag {name}',
  approverAppliedBy: 'curtha i bhfeidhm ag {name}',
  kindCreatePage: 'Leathanach nua',
  kindUpdatePage: 'Nuashonrú molta',
  kindArchivePage: 'Cartlannú',
  statusConflict: 'Coimhlint · athraíodh an leathanach',
  statusPending: 'Ag fanacht le hathbhreithniú',
  statusApproved: 'Ceadaithe',
  statusRejected: 'Curtha i leataobh',
  statusWithdrawn: 'Tarraingthe siar',
  statusSuperseded: 'Sáraithe',
  errRevisionConflict: 'Athraíodh an leathanach seo agus tú á athbhreithniú.',
  errProposalChanged:
    'Athraíodh an moladh seo agus tú á athbhreithniú. Athbhreithnigh an leagan is déanaí sula gcinneann tú.',
  errPublishRequired:
    'Ní féidir ach le foilsitheoirí de chuid na cuideachta athruithe eolais a cheadú nó leathanaigh a iompórtáil.',
  errProposalLimit:
    'Tá 200 moladh ag fanacht le hathbhreithniú ag do chuideachta cheana. Athbhreithnigh cuid acu sula molann tú tuilleadh.',
  errAuthorLimit:
    'Tá 50 moladh agat ag fanacht le hathbhreithniú cheana. Fan go gcinnfear ar chuid acu, nó tarraing cuid acu siar, sula molann tú tuilleadh.',
  errImportProposalLimit:
    'Chuirfeadh an iompórtáil seo níos mó leathanach athraithe le hathbhreithniú ná mar a fhóireann i scuaine athbhreithnithe do chuideachta (200 ar a mhéad). Cinn ar roinnt moltaí sa chluaisín Le hathbhreithniú, ansin cuir i bhfeidhm arís.',
  errImportChanged:
    'Ní hí an iompórtáil seo an ceann a d’athbhreithnigh tú. Oscail arís í agus athbhreithnigh í sula gcuireann tú i bhfeidhm í.',
  errImportItemNotFound: 'Níl an doiciméad seo mar chuid den iompórtáil a thuilleadh.',
  errIdempotencyConflict:
    'Seoladh an moladh seo cheana le hábhar difriúil. Athlódáil agus bain triail eile as.',
  errImportHashMismatch:
    'Níl comhad sa léargas seo ag teacht lena shuim sheiceála thaifeadta. Cruthaigh an léargas arís agus bain triail eile as.',
  errImportAlreadyApplied: 'Cuireadh an iompórtáil seo i bhfeidhm cheana.',
  errImportDiscarded: 'Caitheadh an iompórtáil seo i leataobh. Roghnaigh comhad an léargais arís.',
  errImportDuplicateItem:
    'Liostaíonn an léargas seo an doiciméad céanna faoi dhó. Cruthaigh an léargas arís.',
  errInvalidImport:
    'Níorbh fhéidir le Poneva glacadh leis an léargas seo. Cruthaigh arís é leis an script léargais agus bain triail eile as.',
  errInvalidInput:
    'Níorbh fhéidir le Poneva glacadh leis an ionchur seo. Seiceáil na réimsí agus bain triail eile as.',
  errImportLimit:
    'Tá an iomarca iompórtálacha ullmhaithe ach gan cur i bhfeidhm. Cuir cuid acu i bhfeidhm nó caith i leataobh iad sula n-ullmhaíonn tú ceann eile.',
  errPageTooLarge: 'Tá leathanach níos mó ná 256 KB. Roinn ina leathanaigh níos lú é.',
  errTooManySections:
    'Tá níos mó ná 2,000 ceannteideal ar leathanach. Roinn ina leathanaigh níos lú é.',
  errPageLimit: 'Tá teorainn 2,000 leathanach eolais bainte amach ag do chuideachta.',
  errCollectionLimit: 'Tá teorainn 100 ábhar bainte amach ag do chuideachta.',
  errProposalNotPending:
    'Cinneadh ar an moladh seo cheana. Is é an stádas a thaispeántar an stádas reatha.',
  errRequesterRemoved:
    'Níl an duine a mhol é seo sa chuideachta seo a thuilleadh, mar sin ní féidir é a cheadú.',
  errRevisionAlreadyCurrent: 'Is é an leagan sin an leagan reatha cheana.',
  errPageArchived:
    'Cartlannaíodh an leathanach seo agus tú á athbhreithniú. Athbhreithnigh an moladh arís sula gcinneann tú.',
  errAlreadyArchived: 'Tá an leathanach seo cartlannaithe cheana.',
  errProposalForbidden: 'Ní féidir ach leis an duine a mhol é seo é a tharraingt siar.',
  errUnavailable: 'Níl leathanaigh eolais ar fáil faoi láthair.',
  errTimeout: 'Thóg Poneva rófhada le freagra a thabhairt.',
  errItemTooLarge: 'Tá {path} níos mó ná 256 KB. Roinn ina leathanaigh níos lú é.',
  errItemTooManySections:
    'Tá níos mó ná 2,000 ceannteideal in {path}. Roinn ina leathanaigh níos lú é.',
  errItemHashMismatch:
    'Níl {path} ag teacht lena shuim sheiceála thaifeadta. Cruthaigh an léargas arís agus bain triail eile as.',
  errNoLongerAvailable: 'Níl an mhír seo ar fáil duit a thuilleadh.',
  errTooLargeToSend: 'Tá an comhad seo rómhór le seoladh.',
  cardChecking: 'Ag seiceáil an stádais…',
  cardNotAvailable: 'Níl sé ar fáil',
  cardStatusUnavailable: 'Níl an stádas ar fáil',
  cardUnshowable: 'Níorbh fhéidir an nuashonrú eolais molta seo a thaispeáint.',
  cardEyebrow: 'Nuashonrú eolais molta',
  cardLabel: 'Nuashonrú eolais molta · {title}',
  cardMissing: 'Níl an moladh seo ar fáil duit a thuilleadh.',
  cardUnknown:
    'Níorbh fhéidir linn seiceáil cén chaoi a bhfuil an moladh seo. Oscail an t-athbhreithniú chun a stádas a fheiceáil.',
  cardCheckAgain: 'Seiceáil arís',
  cardReview: 'Athbhreithnigh an nuashonrú',
  statusLineApproved: 'Tuiscint cheadaithe',
  readyCount:
    'one:réidh le cuardach|two:réidh le cuardach|few:réidh le cuardach|many:réidh le cuardach|other:réidh le cuardach',
  preparingCount: 'one:á ullmhú|two:á ullmhú|few:á ullmhú|many:á ullmhú|other:á ullmhú',
  attentionCount:
    'one:aird ag teastáil|two:aird ag teastáil|few:aird ag teastáil|many:aird ag teastáil|other:aird ag teastáil',
  topicsExplore: 'Taiscéal ábhar',
  topicsAllPages: 'Gach leathanach',
  topicsOpenPages: 'Oscail Leathanaigh',
  topicsEmpty:
    'Níl aon leathanaigh cheadaithe fós. Coinníonn leathanaigh tuiscint fhadfhoirme na cuideachta mar aon lena stair iomlán leaganacha.',
  reviewsTitle: 'Nuashonruithe leathanaigh molta',
  reviewsTitleMine: 'Do chuid nuashonruithe leathanaigh molta',
  reviewsIntro:
    'Is leagan iarrthach iomlán é gach moladh, mar aon lena chúis agus a fhianaise. Ní athraíonn aon rud go dtí go gceadaíonn tú an leagan cruinn sin.',
  reviewsIntroMine:
    'Fanann do mholtaí anseo go dtí go ndéanann foilsitheoir de chuid na cuideachta athbhreithniú orthu. Fanann na leathanaigh mar atá go dtí sin.',
  loadPagesFailed: 'Níorbh fhéidir linn leathanaigh eolais a lódáil.',
  loadProposalsFailed: 'Níorbh fhéidir linn nuashonruithe leathanaigh molta a lódáil.',
  loadMoreFailed: 'Níorbh fhéidir linn tuilleadh leathanach a lódáil.',
  otherPages: 'Leathanaigh eile',
  loadTopicFailed: 'Níorbh fhéidir linn an t-ábhar seo a lódáil.',
  revisionShort: 'l{n}',
  updatedOn: 'Nuashonraithe {date}',
  emptyTitle: 'Níl aon leathanaigh eolais fós.',
  emptyBody:
    'Coinníonn leathanaigh tuiscint cheadaithe fhadfhoirme do chuideachta — treo, cinntí agus bealaí oibre — agus coinnítear gach leagan. Iompórtáil ó léargas stóir nó tosaigh leathanach sa chomhrá; ceadaíonn foilsitheoir gach leathanach sula n-áirítear é mar eolas na cuideachta.',
  importFromSnapshot: 'Iompórtáil ó léargas stóir',
  startInChat: 'Tosaigh leathanach sa chomhrá',
  startInChatPrompt:
    'Cabhraigh liom leathanach eolais a thosú dár gcuideachta. Fiafraigh díom cad ba cheart a bheith ann agus ná cum aon ábhar. Fanann sé ina mholadh go dtí go gceadaíonn foilsitheoir de chuid na cuideachta é.',
  loadingPages: 'Ag lódáil leathanaigh eolais…',
  filterLabel: 'Scag leathanaigh de réir teidil',
  filterPlaceholder: 'Scag leathanaigh',
  importButton: 'Iompórtáil',
  showingTopic: 'Ag taispeáint {topic}',
  showAllTopics: 'Taispeáin gach ábhar',
  loadingTopic: 'Ag lódáil an ábhair seo…',
  noMatch: 'Níl aon leathanach ag teacht le “{filter}”.',
  topicNoPages: 'Níl aon leathanaigh cheadaithe san ábhar seo fós.',
  loading: 'Ag lódáil…',
  loadMore: 'Lódáil tuilleadh leathanach',
  metaApproved: 'ceadaithe {date}',
  metaRepositoryAuthoritative: 'is é an stór an fhoinse údarásach fós',
  loadPageFailed: 'Níorbh fhéidir linn an leathanach seo a lódáil.',
  loadHistoryFailed: 'Níorbh fhéidir linn stair na leaganacha a lódáil.',
  outlineLabel: 'Ranna an leathanaigh',
  outlineToggle: 'Ar an leathanach seo',
  loadingHistory: 'Ag lódáil stair na leaganacha…',
  historyLabel: 'Stair na leaganacha',
  historyIntro:
    'Coinnítear gach leagan ceadaithe. Nuair a athchóiríonn tú leagan níos luaithe, cruthaítear moladh le hathbhreithniú; ní scriostar leaganacha níos déanaí choíche.',
  historyCurrent: 'Reatha',
  historyViewing: 'Á fheiceáil',
  historyView: 'Féach',
  historyViewAria: 'Féach ar leagan {n}',
  restoreAria: 'Athchóirigh mar mholadh: leagan {n}',
  restoreCreating: 'Ag cruthú an mholta…',
  restore: 'Athchóirigh mar mholadh',
  restoreUnconfirmed:
    'Níorbh fhéidir linn a dhearbhú gur cruthaíodh an moladh. Seiceáil Le hathbhreithniú sula mbaineann tú triail eile as.',
  editTooLarge:
    'Tá an leathanach seo níos mó ná 256 KB. Roinn ina leathanaigh níos lú é sula molann tú é.',
  editConflict:
    'Athraíodh an leathanach seo agus tú á chur in eagar. Cóipeáil do théacs, oscail an leagan is déanaí agus mol an t-athrú arís.',
  editUnconfirmed:
    'Níorbh fhéidir linn a dhearbhú gur seoladh do mholadh. Seiceáil Le hathbhreithniú sula seolann tú arís é.',
  editHeading: 'Mol athrú',
  editIntro:
    'Tá leagan {n} á chur in eagar agat. Déanann foilsitheoir de chuid na cuideachta athbhreithniú ar an athrú cruinn sula mbíonn sé ina leagan {next}; go dtí sin fanann an leathanach mar atá.',
  editOutdated:
    'Ceadaíodh leagan níos nuaí agus tú á chur in eagar. Cóipeáil do théacs, ansin tosaigh arís ón leagan is déanaí ionas nach gcaillfear aon rud a d’athraigh sé.',
  editContentLabel: 'Ábhar an leathanaigh (Markdown)',
  editReasonLabel: 'Cén fáth an t-athrú seo?',
  editReasonPlaceholder: 'Cad a athraíodh, agus cá as a dtagann sé.',
  editSending: 'Á sheoladh…',
  editSend: 'Seol le haghaidh athbhreithnithe',
  editDiscardConfirm:
    'An bhfuil tú ag iarraidh an t-athrú seo a chaitheamh i leataobh? Níor seoladh aon rud a d’athraigh tú.',
  editNoChanges: 'Níl aon athruithe fós.',
  editNeedsContent: 'Tá ábhar de dhíth ar leathanach.',
  exportFailed: 'Níorbh fhéidir linn an leathanach seo a easpórtáil. Bain triail eile as.',
  askPagePrompt: 'Ceist faoin leathanach eolais “{title}” (leagan {n}, {link}):',
  askPageSectionPrompt: 'Ceist faoin leathanach eolais “{title}” § {section} (leagan {n}, {link}):',
  pageMissingTitle: 'Níl an leathanach seo ar fáil.',
  pageMissingBody:
    'B’fhéidir gur cartlannaíodh é, nó b’fhéidir nach bhfuil rochtain agat ar eolas na cuideachta seo a thuilleadh.',
  pageArchived: 'Cartlannaithe',
  viewingRevisionCurrent: 'Tá leagan {n} á fheiceáil agat; is é {current} an leagan reatha.',
  viewingRevisionOld: 'Tá leagan {n} á fheiceáil agat. Ní hé an leagan reatha é.',
  openCurrent: 'Oscail an leagan reatha',
  archivedBanner:
    'Tá an leathanach seo cartlannaithe. Ní úsáidtear é i bhfreagraí a thuilleadh; coinnítear a stair.',
  pageViewsLabel: 'Amhairc leathanaigh',
  tabRead: 'Léigh',
  tabHistory: 'Stair',
  unknownSection:
    'Níl an roinn naschta mar chuid den leagan seo. Ag taispeáint an leathanaigh ar fad.',
  askAboutPage: 'Cuir ceist faoin leathanach seo',
  exporting: 'Á easpórtáil…',
  exportMarkdown: 'Easpórtáil Markdown',
  loadSuggestionFailed: 'Níorbh fhéidir linn an moladh seo a lódáil.',
  evidenceSource: 'Foinse',
  evidenceFact: 'Comhthéacs cuideachta',
  evidenceResult: 'Obair shábháilte',
  evidenceUrl: 'Leathanach gréasáin',
  evidenceDecision: 'Cinneadh',
  evidenceReference: 'Tagairt',
  evidenceOpenPage: 'Oscail an leathanach eolais',
  evidenceOpenSource: 'Oscail an fhoinse',
  evidenceOpenFact: 'Oscail comhthéacs na cuideachta',
  evidenceOpenResult: 'Oscail an obair shábháilte',
  evidenceOpenUrl: 'Oscail an leathanach gréasáin',
  evidenceOpenDecision: 'Oscail an cinneadh',
  evidenceOpenReference: 'Oscail an tagairt',
  evidenceDecisionNote: 'Cinneadh taifeadta. Níl aon rud in Poneva le hoscailt.',
  evidenceFactGone: 'Níl an comhthéacs cuideachta seo sábháilte a thuilleadh.',
  evidencePageNoRevision: 'Níl aon leagan ceadaithe ag an leathanach seo le hoscailt.',
  evidencePrivateExcerpt: 'Fianaise phríobháideach — níor roinneadh ach an sliocht thuas.',
  evidencePrivate: 'Fianaise phríobháideach — níor roinneadh a hábhar leat.',
  evidenceHeading: 'Fianaise',
  evidenceNone: 'Níor ceanglaíodh aon fhianaise. Meáigh an chúis thuas ann féin.',
  changeAdded: 'Curtha leis',
  changeRemoved: 'Bainte',
  changeChanged: 'Athraithe',
  changeUnchanged: 'Gan athrú',
  moreLineCount: 'one:líne eile|two:líne eile|few:líne eile|many:líne eile|other:líne eile',
  moreUnchangedLineCount:
    'one:líne eile gan athrú|two:líne eile gan athrú|few:líne eile gan athrú|many:líne eile gan athrú|other:líne eile gan athrú',
  unchangedLineCount:
    'one:líne gan athrú|two:líne gan athrú|few:líne gan athrú|many:líne gan athrú|other:líne gan athrú',
  skipAdded: '{lines} — le feiceáil sa leagan iomlán',
  skipRemoved: '{lines} bainte',
  cutUnchanged: '{lines} nach dtaispeántar',
  cutChanged: '{lines} nach dtaispeántar, {changes}. Seiceáil iad sa leagan iomlán.',
  cutAddedRemoved: '{added} curtha leis agus {removed} bainte',
  cutAdded: '{added} curtha leis',
  cutRemoved: '{removed} bainte',
  lineAddedSr: 'Curtha leis:',
  lineRemovedSr: 'Bainte:',
  noLinesAdded: 'Roinn nua. Tá a téacs sa leagan iomlán thíos.',
  noLinesRemoved: 'Bhainfí an roinn seo den leathanach.',
  noLinesChanged: 'Athraíonn an roinn seo. Tá a téacs sa leagan iomlán thíos.',
  diffHeading: 'Athruithe',
  outcomeArchived: 'Cartlannaithe.',
  outcomeArchivedBody:
    'Ní úsáidtear {title} i bhfreagraí a thuilleadh agus níl sé ar liosta na leathanach níos mó. Fanann a leaganacha, an moladh seo agus an cinneadh i stair an leathanaigh.',
  openArchivedPage: 'Oscail an leathanach cartlannaithe',
  outcomeApproved: 'Ceadaithe.',
  outcomeApprovedRevision: 'Is é leagan {n} anois an leagan ceadaithe de {title}.',
  outcomeApprovedPlain: 'Ceadaíodh an moladh seo.',
  outcomeRestored:
    'Tá an leathanach ar ais ar liosta na leathanach agus úsáidtear é i bhfreagraí arís.',
  outcomeKept:
    'Fanann an moladh, an cinneadh agus gach leagan níos luaithe i stair an leathanaigh.',
  openPage: 'Oscail an leathanach',
  outcomeDismissed: 'Curtha i leataobh.',
  outcomeWithdrawn: 'Tarraingthe siar.',
  outcomeSuperseded: 'Sáraithe.',
  outcomeSupersededBody:
    'Rinne leagan níos nuaí, moladh níos nuaí nó iompórtáil ón stór an moladh seo as dáta. Níor athraigh sé aon rud as féin.',
  outcomeUnchanged: 'Fanann an leathanach mar atá.',
  approveNewPage: 'Ceadaigh an leathanach nua',
  approveArchive: 'Ceadaigh an cartlannú',
  approveRestoreRevision: 'Athchóirigh agus ceadaigh leagan {n}',
  approveRevision: 'Ceadaigh leagan {n}',
  approveArchiveNote:
    'Má cheadaíonn tú é, cartlannófar an leathanach seo do gach duine ag {company}.',
  approvePublishNote: 'Má cheadaíonn tú é, foilseofar an leagan seo do gach duine ag {company}.',
  approvePublishEvidenceNote:
    'Má cheadaíonn tú é, foilseofar an leagan seo agus na sleachta fianaise thuas do gach duine ag {company}.',
  archivedTitle: 'Tá an leathanach seo cartlannaithe.',
  alreadyArchivedBody:
    'Ní athródh ceadú aon rud, mar sin ní féidir an moladh seo ach a chur i leataobh.',
  archivedRestoreBody:
    'Athchóireoidh ceadú é: filleann an leathanach ar liosta na leathanach, ar an gcuardach agus ar fhreagraí leis an leagan seo.',
  staleRevisionAction: 'Cuir i gcomparáid leis an leagan is déanaí',
  staleProposalTitle: 'Athraíodh an moladh seo agus tú á athbhreithniú.',
  staleProposalAction: 'Athbhreithnigh an leagan is déanaí',
  staleArchivedTitle:
    'Cartlannaíodh an leathanach seo agus tú á athbhreithniú. Thabharfadh ceadú an mholta seo ar ais é.',
  staleArchivedAction: 'Athbhreithnigh arís',
  suggestionMissingTitle: 'Níl an moladh seo ar fáil.',
  suggestionMissingBody:
    'B’fhéidir gur tarraingíodh siar é, nó is le duine eile é agus níor seoladh é le haghaidh athbhreithniú na cuideachta.',
  decideUnconfirmed:
    'Níorbh fhéidir linn do chinneadh a dhearbhú. Is é an stádas a thaispeántar an ceann is déanaí ó Poneva; seiceáil é sula mbaineann tú triail eile as.',
  decideFailed: 'Níorbh fhéidir linn do chinneadh a shábháil.',
  discussPrompt: 'Cabhraigh liom an nuashonrú eolais molta ar “{title}” ({link}) a fheabhsú.',
  conflictBody:
    'Scríobhadh an moladh seo i gcoinne leagan {base}; is é {current} an leagan reatha. Dá gceadófaí é, scríobhfaí thar an athrú sin, mar sin ní féidir é a cheadú mar atá.',
  conflictBodyPlain:
    'Scríobhadh an moladh seo i gcoinne leagan níos luaithe, mar sin ní féidir é a cheadú mar atá.',
  openLatest: 'Oscail an leagan is déanaí',
  reworkInChat: 'Athoibrigh sa chomhrá',
  factReason: 'Cúis',
  factNoReason: 'Níor tugadh aon chúis.',
  factAudience: 'Lucht léite',
  factRevision: 'Leagan',
  revisionNew: 'Leathanach nua, leagan 1',
  revisionArchiveAfter: 'Cartlannú tar éis leagan {n}',
  revisionWrittenAgainst: 'Scríofa i gcoinne leagan {base}; is é {current} an leagan reatha',
  revisionCurrentToProposed: 'Leagan reatha {base} → leagan molta {next}',
  revisionProposed: 'Leagan molta {next}',
  proposedPage: 'Leathanach molta',
  archivingHeading: 'Cad a dhéanann cartlannú',
  archivingBody:
    'Ní úsáidtear an leathanach i bhfreagraí a thuilleadh agus baintear de liosta na leathanach é. Coinnítear a leaganacha agus an cinneadh seo.',
  noComparison: 'Níl comparáid ranna ar fáil don mholadh seo.',
  showComplete: 'Taispeáin an leagan iomlán',
  approving: 'Á cheadú…',
  dismissing: 'Á chur i leataobh…',
  dismiss: 'Cuir i leataobh',
  withdrawing: 'Á tharraingt siar…',
  withdraw: 'Tarraing siar',
  editInChat: 'Cuir in eagar sa chomhrá',
  waitingForPublisher:
    'Ag fanacht go ndéanfaidh foilsitheoir de chuid na cuideachta athbhreithniú air.',
  snapshotTooLarge: 'Tá an léargas seo níos mó ná 8 MB. Cruthaigh é le níos lú doiciméad.',
  snapshotNotSnapshot:
    'Ní léargas eolais é an comhad seo. Roghnaigh an comhad JSON a scríobh an script léargais.',
  snapshotEmpty: 'Níl aon doiciméad sa léargas seo.',
  readDocumentFailed: 'Níorbh fhéidir linn an doiciméad seo a léamh. Bain triail eile as.',
  readingDocument: 'Ag léamh an doiciméid…',
  hideText: 'Folaigh an téacs',
  readText: 'Léigh an téacs',
  textOf: 'Téacs {title}',
  gitSnapshot: 'Léargas Git {commit}',
  repositorySnapshot: 'Léargas stóir',
  importNewHeading: '{pages} · ceadaithe nuair a chuireann tú i bhfeidhm',
  importNewNote:
    'Foilsítear gach ceann acu mar leathanach ceadaithe do gach duine ag {company}, gan athbhreithniú breise. Léigh gach ceann sula gcuireann tú i bhfeidhm.',
  importChangedHeading: '{pages} · seolta le haghaidh athbhreithnithe',
  importChangedNote:
    'Déantar nuashonrú molta de gach ceann acu. Ní athraíonn a leathanach ach nuair a cheadaíonn foilsitheoir é sa chluaisín Le hathbhreithniú, a thaispeánann cad a athraíodh.',
  unchangedDocumentCount:
    'one:doiciméad gan athrú|two:dhoiciméad gan athrú|few:dhoiciméad gan athrú|many:ndoiciméad gan athrú|other:doiciméad gan athrú',
  unchangedNote:
    'Tá siad seo ag teacht lena leathanaigh cheadaithe cheana. Ní scríobhtar aon rud dóibh.',
  stagedHeading: 'Ullmhaithe ach gan cur i bhfeidhm',
  excludedSummary: '{documents} fágtha as an léargas seo',
  countsLine: '{newPages} · {changedPages} le hathbhreithniú · {unchanged} gan athrú',
  importAlreadyDiscarded: 'Caitheadh an iompórtáil seo i leataobh cheana.',
  confirmLabel: 'Deimhnigh an iompórtáil',
  unchangedKeepCount:
    'one:doiciméad gan athrú a choinníonn a leathanach|two:dhoiciméad gan athrú a choinníonn a leathanaigh|few:dhoiciméad gan athrú a choinníonn a leathanaigh|many:ndoiciméad gan athrú a choinníonn a leathanaigh|other:doiciméad gan athrú a choinníonn a leathanaigh',
  confirmBody:
    'An bhfuil tú ag iarraidh an iompórtáil seo a chur i bhfeidhm do gach duine ag {company}? Ceadófar {newPages} mar leagan 1, fanfaidh {changedPages} le hathbhreithniú, agus {unchanged}. Tarraingítear siar moltaí iompórtála níos luaithe do na leathanaigh seo.',
  applying: 'Á chur i bhfeidhm…',
  applyImport: 'Cuir an iompórtáil i bhfeidhm',
  chooseAnother: 'Roghnaigh comhad eile',
  allCurrent: 'Tá gach rud sa léargas seo cothrom le dáta cheana.',
  importApplied: 'Cuireadh an iompórtáil i bhfeidhm.',
  appliedSummary:
    '{pages} cruthaithe · {changes} ag fanacht le hathbhreithniú · {unchanged} gan athrú.',
  appliedIndexing:
    'Beidh leathanaigh nua inchuardaithe sa chomhrá nuair a bheidh an t-innéacsú críochnaithe. Taispeántar an dul chun cinn in ullmhú na bhfoinsí.',
  openPages: 'Oscail Leathanaigh',
  reviewChanges: 'Athbhreithnigh {changes}',
  checkIndexing: 'Seiceáil dul chun cinn an innéacsaithe',
  sendSnapshotFailed: 'Níorbh fhéidir linn an léargas seo a sheoladh. Bain triail eile as.',
  openStagedFailed: 'Níorbh fhéidir linn an iompórtáil ullmhaithe seo a oscailt.',
  applyUnconfirmed:
    'Níorbh fhéidir linn a dhearbhú ar cuireadh an iompórtáil i bhfeidhm. Seiceáil Leathanaigh sula mbaineann tú triail eile as.',
  applyFailed: 'Níorbh fhéidir linn an iompórtáil seo a chur i bhfeidhm.',
  importHeading: 'Iompórtáil leathanaigh ón stór',
  backToPages: 'Ar ais chuig na leathanaigh',
  importLead:
    'Cruthaigh léargas le {command}, ansin roghnaigh an comhad. Feicfidh tú gach doiciméad agus cad a d’athródh sé sula sábháiltear aon rud.',
  snapshotFileLabel: 'Comhad léargais eolais',
  readingSnapshot: 'Ag léamh an léargais…',
  openingStaged: 'Ag oscailt na hiompórtála ullmhaithe…',
  chooseSnapshot: 'Roghnaigh comhad léargais',
  factOrigin: 'Bunús',
  factContents: 'Ábhar',
  importOnlyListed: 'Ní iompórtáiltear ach na doiciméid atá liostaithe anseo.',
  importRepositoryAuthoritative:
    'Fanann an stór údarásach; déantar moltaí le hathbhreithniú de dhoiciméid athraithe.',
  overviewReviewChanges: 'Athbhreithnigh athruithe',
  overviewConnectAgents: 'Ceangail gníomhairí seachtracha',
  overviewEyebrow: 'Tuiscint chomhroinnte',
  overviewTitle: '{company}, i gcomhthéacs.',
  overviewLeadFallback:
    'Tosaíonn eolas do chuideachta leis an gcomhthéacs a roinneann tú. Tógaimis tuiscint ar do ghnó le chéile.',
  overviewBody:
    'Tugann comhthéacs na cuideachta agus ábhar foinseach pointe tosaigh do Poneva — ní gach rud atá le fios faoi {company}. Lean ort ag tógáil na tuisceana seo de réir mar a fhorbraíonn do ghnó.',
  overviewAskPrompt:
    'Cad atá ar eolas agat faoinár gcuideachta, agus cad ba úsáideach a chur leis?',
  overviewAsk: 'Cuir ceist faoi {company}',
  overviewAddSources: 'Cuir foinsí leis',
  contextEyebrow: 'Cad a thugann comhthéacs d’fhreagraí',
  contextTitle: 'An gnó taobh thiar den cheist.',
  contextBody:
    'Míníonn foinsí suímh ghréasáin an gnó poiblí. Cuireann nótaí cuideachta do théarmaíocht, do thosaíochtaí agus do bhealach oibre leis.',
  contextPrompt:
    'Cabhraigh liom tosaíochtaí na cuideachta agus na roghanna oibre ba cheart dúinn a mheabhrú a shoiléiriú.',
  contextAction: 'Tóg ár dtuiscint',
  learnEyebrow: 'Spás le foghlaim',
  learnTitle: 'Tosaigh leis an rud is tábhachtaí anois.',
  learnBody:
    'Tabhair isteach ábhar foinseach nó soiléirigh conas a oibríonn do chuideachta. Is féidir le Poneva athruithe buana a mholadh duit le hathbhreithniú.',
  learnPrompt:
    'Bunaithe ar eolas reatha ár gcuideachta, cén fhaisnéis thábhachtach atá in easnamh don obair is mian linn a dhéanamh?',
  learnAction: 'Pléigh cad a bheadh úsáideach',
  canvasEmptyTitle: 'Téann beagán comhthéacs i bhfad.',
  canvasEmptyBody:
    'Is é próifíl do chuideachta an pointe tosaigh. Cuir ábhar foinseach agus nótaí athbhreithnithe leis chun cabhrú le Poneva d’obair a thuiscint.',
  pageEyebrow: 'Spás oibre {company}',
  pageTitle: 'Eolas na cuideachta',
  pageDescription: 'Na foinsí agus an tuiscint atá taobh thiar d’obair Poneva.',
  tabOverview: 'Forléargas',
  tabPages: 'Leathanaigh',
  tabSources: 'Foinsí',
  tabReview: 'Le hathbhreithniú',
  proposalApproved: 'Comhthéacs cuideachta ceadaithe',
  proposalDismissed: 'Moladh curtha i leataobh',
  proposalRemoval: 'Baint mholta',
  proposalCorrection: 'Ceartúchán molta',
  proposalContext: 'Comhthéacs cuideachta molta',
  proposalCurrent: 'An tuiscint reatha',
  proposalFactGone:
    'Níl an fhíric shábháilte ar fáil a thuilleadh. Athnuaigh eolas na cuideachta sula ndéanfaidh tú athbhreithniú ar an mbaint seo.',
  proposalReviewFallback: 'Déan athbhreithniú ar an gcomhthéacs cuideachta molta.',
  proposalNotSaved: 'Níl sé sábháilte fós. Fanann na foinsí bunaidh gan athrú.',
  proposalWaiting:
    'Ag fanacht le hathbhreithniú · cinneann foilsitheoir de chuid na cuideachta air sa Bhosca isteach',
  proposalSaving: 'Á shábháil…',
  proposalApproveRemoval: 'Ceadaigh an bhaint',
  proposalApproveClarification: 'Ceadaigh an soiléiriú',
  factLabel: 'Fíric cuideachta',
  factEyebrow: 'Fíric · Gach duine ag {company}',
  factSuggestCorrection: 'Mol ceartúchán',
  factAskPrompt:
    'Cabhraigh liom an comhthéacs cuideachta sábháilte seo a thuiscint nó a shoiléiriú: “{content}”',
  factAsk: 'Cuir ceist faoi',
  companyContextHeading: 'Comhthéacs cuideachta',
  companyContextPrompt:
    'Ba mhaith liom eolas ár gcuideachta a shoiléiriú. Cabhraigh liom athbhreithniú a dhéanamh ar a bhfuil ar eolas againn agus nuashonrú a mholadh.',
  companyContextEmpty:
    'Níl aon nótaí ceadaithe fós. Tosaigh comhrá faoi do chuideachta, nó cuir ábhar foinseach leis thíos.',
  refineInChat: 'Feabhsaigh sa chomhrá',
  reviewPanelLabel: 'Athruithe eolais le hathbhreithniú',
  suggestedUpdatesHeading: 'Nuashonruithe molta',
  suggestedUpdatesIntro:
    'Moltaí ó do chomhráite. Is tusa a chinneann cad a bheidh mar chuid d’eolas buan do chuideachta.',
  reviewEmptyTitle: 'Níl aon rud ag fanacht le d’athbhreithniú.',
  reviewEmptyBody:
    'Nuair a mholann Poneva athrú ar eolas do chuideachta, gheobhaidh tú anseo é. Teastaíonn do cheadú i gcónaí le haghaidh athruithe buana.',
  reviewEmptyPrompt:
    'Cabhraigh liom athbhreithniú a dhéanamh ar eolas ár gcuideachta agus mol cad ba úsáideach a shoiléiriú ina dhiaidh sin.',
  inclusionPendingApproval: 'Seoladh an t-athrú ar chur san áireamh san eolas le ceadú.',
  sourcesFileIncluded: 'Tá an comhad san áireamh i gcuardach eolais dá lucht féachana reatha.',
  sourcesAddFailed: 'Níorbh fhéidir an fhoinse seo a chur leis.',
  sourcesHeading: 'An t-ábhar taobh thiar de na freagraí.',
  sourcesIntro:
    'Cuardaíonn Poneva an t-ábhar foinseach iomlán, ní an forléargas amháin. Coinnigh na bunleaganacha, féach cad atá réidh, agus roghnaigh cad a mhúnlaíonn do chuid freagraí.',
  addSourceHeading: 'Cuir ábhar ó do chuideachta leis',
  addSourceIntro:
    'Fanann foinsí uaslódáilte príobháideach i do Leabharlann agus ní úsáidtear iad ach i do chuid freagraí féin. Roghnaigh Comhroinn nuair is mian leat iad a chur ar fáil do chomhghleacaithe.',
  uploadSource: 'Uaslódáil foinse',
  addSourcePrompt:
    'Cabhraigh liom ráiteas cuideachta a chur leis mar fhoinse inmheánach chomhroinnte. Fiafraigh díom cad ba mhaith liom a thaifeadadh; ná cum aon ábhar. Teastaíonn mo cheadú fós le haghaidh athruithe buana ar thuiscint na cuideachta.',
  addThroughChat: 'Cuir leis tríd an gcomhrá',
  addingSource: 'Á chur leis…',
  addToKnowledge: 'Cuir leis an eolas',
  uploadFormats: 'TXT, Markdown, CSV agus JSON · Suas le 5 MB in aghaidh an chomhaid',
  sourceExcluded: 'Fágtha as freagraí',
  sourcePreparationFailed: 'Theip ar an ullmhú',
  sourcePreparing: 'Á ullmhú don chuardach',
  sourceWaiting: 'Ag fanacht le hullmhú',
  sourceReadinessUnknown: 'Níl staid an ullmhaithe ar fáil',
  sourceRetryQueued:
    'Tá an t-ullmhú sa scuaine. Nuashonrófar an staid nuair a bheidh sé críochnaithe.',
  sourceIncludedNotice: 'Tá an fhoinse san áireamh. Ullmhóidh Poneva don chuardach í.',
  sourceExcludedNotice: 'Fágtha as freagraí. Coinnítear an fhoinse bhunaidh.',
  sourceUpdateFailed: 'Níorbh fhéidir an fhoinse seo a nuashonrú.',
  sourceOriginalMaterial: 'Ábhar foinseach bunaidh',
  sourceDiscuss: 'Pléigh sa chomhrá',
  sourceDiscussPrompt: 'Cabhraigh liom “{title}” a thuiscint nó a shoiléiriú.',
  sourceExclude: 'Fág as freagraí',
  sourceInclude: 'Cuir san áireamh i bhfreagraí',
  sourcesLoadFailed: 'Níorbh fhéidir linn do chuid foinsí a lódáil.',
  sourceLibraryLabel: 'Leabharlann foinsí na cuideachta',
  sourceListCaption: 'Foinsí bunaidh · san áireamh agus fágtha as',
  sourceSearchLabel: 'Cuardaigh foinsí na cuideachta',
  sourceSearchPlaceholder: 'Cuardaigh do chuid foinsí…',
  sourcesFinding: 'Do chuid foinsí á n-aimsiú…',
  sourcePagesLabel: 'Leathanaigh na bhfoinsí',
  sourceRange: '{from}–{to} as {count}',
  sourceCount: 'one:foinse|two:fhoinse|few:fhoinse|many:bhfoinse|other:foinse',
  sourcePrevious: 'Roimhe Seo',
  sourceNext: 'Ar aghaidh',
  sourceNoMatchTitle: 'Níl aon fhoinsí comhoiriúnacha ann.',
  sourceNoMatchBody: 'Bain triail as frása nó ainm foinse eile.',
  sourceEmptyTitle: 'Tabhair pointe tosaigh níos láidre do do cheisteanna.',
  sourceEmptyBody:
    'Cuir doiciméid cuideachta, sonraí táirge nó nótaí oibre leis. Is féidir le Poneva an t-ábhar foinseach iomlán a úsáid i gcomhráite agus i Skills.',
  indexCheckFailed: 'Níorbh fhéidir linn ullmhú na bhfoinsí a sheiceáil.',
  indexRetryQueued:
    'Cuireadh iontrálacha eolais ar theip orthu sa scuaine le hullmhú. Níor athraíodh d’ábhar foinseach.',
  indexQueueFailed: 'Níorbh fhéidir linn an t-ullmhú a chur sa scuaine. Bain triail eile as.',
  indexPreparing: 'Eolas nua á ullmhú do do chomhráite…',
  indexAttention: 'Tá aird ag teastáil ó chuid den eolas.',
  queuing: 'Á chur sa scuaine…',
  retryPreparation: 'Ullmhaigh arís',
  sourceKindStatement: 'Ráiteas cuideachta',
  sourceKindWebsite: 'Suíomh gréasáin',
  sourceKindDocument: 'Doiciméad',
  factAnswers: 'one:fhreagra|two:fhreagra|few:fhreagra|many:bhfreagra|other:freagra',
  factUsedThisWeek: 'Úsáidte an tseachtain seo: {answers}',
  factLastUsed: 'úsáidte go deireanach: {when}',
  factToday: 'inniu',
  factYesterday: 'inné',
  factImpact:
    'Téann an t-athrú seo i bhfeidhm ar fhíric a úsáideadh an tseachtain seo ({answers}).',
  factCorrectionAbout: 'Maidir leis an bhfíric chuideachta seo: “{content}” ({link})',
  factCorrectionOutdated: 'Tá sé seo as dáta:',
  sourceCanvasRecorded: 'Ábhar foinseach taifeadta',
  sourceCanvasNotIncluded:
    'Níl sé san áireamh in eolas na cuideachta. Coinnítear an bunleagan le haghaidh tagartha agus is féidir é a úsáid fós i gcomhrá ar leith.',
  sourceCanvasOpenOriginal: 'Oscail an fhoinse bhunaidh',
  sourceCanvasUnavailable: 'Níl ábhar na foinse ar fáil.',
  sourceCanvasDiscussPrompt: 'Cabhraigh liom “{title}” a thuiscint nó a shoiléiriú.',
  sourceCanvasDiscuss: 'Pléigh an fhoinse seo',
  sourceCanvasCorrectionNote:
    'Éiríonn ceartúchán ina chomhthéacs cuideachta molta. Ní athraítear an fhoinse thaifeadta.',
  contextCanvasEyebrow: 'Comhthéacs cuideachta atá ar fáil',
  contextCanvasTitle: 'An t-eolas taobh thiar den chomhrá seo.',
  contextCanvasBody:
    'Tuiscint cheadaithe agus an t-ábhar foinseach a chuir do chuideachta leis. Ar fáil sa chomhrá agus in Skills.',
  contextCanvasOpen: 'Oscail Eolas',
};

export default ga;
